import { RG_TYPE as r } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel as i } from "../../../utils/rg-util/index3.js";
import { isAmenityTechSpace as m } from "../../queries/index.js";
import { getPerimeter as o } from "../index8.js";
const g = (e, t) => o(i(e, r.TechnicalSpace, t).filter(m));
export {
  g as getLevelAmenitiesPerimeter
};
//# sourceMappingURL=index2.js.map
